module.exports = __webpack_public_path__ + "media/audio3.267eb957.mp3";